<template>
  <div class="news">
    <el-menu
        class="menu"
        style="padding-left: 0px"
        :default-active="pid"
        background-color="#fff"
        text-color="#000"
        @select="selectItem"
        active-text-color="#ffd04b">
      <!--
      <el-menu-item index="1">
        <span slot="title">全部动态</span>
      </el-menu-item>
      -->
      <el-menu-item index="3" style="padding-left: 0px">
        <span slot="title">新品发布</span>
      </el-menu-item>
      <el-menu-item index="2" style="padding-left: 0px">
        <span slot="title">最新动态</span>
      </el-menu-item>
    </el-menu>
    <div class="right-content">
      <span style="font-size: 20px; font-weight: bolder;">{{ menuTitle }}</span>
      <router-link to="/newsDetails/1">
        <div class="content-item" v-if="menuTitle==='全部动态' || menuTitle==='新品发布'">
          <div class="content-item-img">
            <img src="../assets/img/news/p8.jpg" width="173" height="109">
            <!--<el-tag class="content-item-img-tag" color="#005DAB"
                    style="width: 74px; height: 24px; line-height: 24px; color: #fff; font-size: 15px;border-style: none; padding: 0px; text-align: center; font-weight: bolder;">
              新品发布
            </el-tag>-->
          </div>
          <div class="item_content">
            <span class="item_title">7月新品第4波来袭！科可瑞尔工控一体机面世!</span>
            <span class="item_time">2024-07-31</span>
            <span
                class="item_tip">7月的最后一天，科可瑞尔推出最新研发成果——一款集前沿技术与航空工艺于一身的工业控制一体机，它将为广大客户的工业智能化之路提供有力的支持。</span>
          </div>
        </div>
      </router-link>
      <el-divider v-if="menuTitle==='全部动态' || menuTitle==='新品发布'"></el-divider>
      <router-link to="/newsDetails/2">
        <div class="content-item" v-if="menuTitle==='全部动态' || menuTitle==='新品发布'">
          <div class="content-item-img">
            <img src="../assets/img/news/p7.png" width="173" height="109">
            <!--<el-tag class="content-item-img-tag" color="#005DAB"
                    style="width: 74px; height: 24px; line-height: 24px; color: #fff; font-size: 15px;border-style: none; padding: 0px; text-align: center; font-weight: bolder;">
              新品发布
            </el-tag>-->
          </div>
          <div class="item_content">
            <span class="item_title">精益求精！科可瑞尔工控机新品上市！</span>
            <span class="item_time">2024-07-19</span>
            <span
                class="item_tip">苏州科可瑞尔航空技术有限公司坚持“秉航空标准 铸智慧臻品”的核心理念，不仅在航空领域精益求精，更将业务能力拓展至轨道、医疗、储能、汽车、工业自动化等领域。凭借卓越的技术创新和深入的行业洞察，科可瑞尔在上述领域均取得了显著的突破和进展。我们致力于将航空级产品的设计和制造理念，应用于更广泛的工业领域，推动各行业的技术进步和产业升级。</span>
          </div>
        </div>
      </router-link>
      <el-divider v-if="menuTitle==='全部动态' || menuTitle==='新品发布'"></el-divider>
      <router-link to="/newsDetails/3">
        <div class="content-item" v-if="menuTitle==='全部动态' || menuTitle==='新品发布'">
          <div class="content-item-img">
            <img src="../assets/img/news/p5.png" width="173" height="109">
            <!--<el-tag class="content-item-img-tag" color="#005DAB"
                    style="width: 74px; height: 24px; line-height: 24px; color: #fff; font-size: 15px;border-style: none; padding: 0px; text-align: center; font-weight: bolder;">
              新品发布
            </el-tag>-->
          </div>
          <div class="item_content">
            <span class="item_title">引领创新！科可瑞尔工业AI服务器新品上市！</span>
            <span class="item_time">2024-07-11</span>
            <span
                class="item_tip">科可瑞尔，凭借超过十年的航空技术深耕经验，是空中客车AIRBUS和中国商飞的合格供应商，为国产大飞机C919、ARJ21等项目提供配套航空系列产品。 </span>
          </div>
        </div>
      </router-link>
      <el-divider v-if="menuTitle==='全部动态' || menuTitle==='新品发布'"></el-divider>
      <router-link to="/newsDetails/4">
        <div class="content-item" v-if="menuTitle==='全部动态' || menuTitle==='新品发布'">
          <div class="content-item-img">
            <img src="../assets/img/news/p6.png" width="173" height="109">
            <!--<el-tag class="content-item-img-tag" color="#005DAB"
                    style="width: 74px; height: 24px; line-height: 24px; color: #fff; font-size: 15px;border-style: none; padding: 0px; text-align: center; font-weight: bolder;">
              新品发布
            </el-tag>-->
          </div>
          <div class="item_content">
            <span class="item_title">第三代半导体GaN：科可瑞尔工业电源模块上新！</span>
            <span class="item_time">2024-07-09</span>
            <span
                class="item_tip">苏州科可瑞尔航空技术有限公司是空客AIRBUS供应商，也是苏州地区唯一为国产大飞机C919配套3款产品的中国商飞合格供应商，同步供货并参与ARJ21和C929项目，现航空产品在国内每三飞机上就有一架配套我司产品。 </span>
          </div>
        </div>
      </router-link>
      <el-divider v-if="menuTitle==='全部动态' || menuTitle==='新品发布'"></el-divider>
      <router-link to="/newsDetails/5">
        <div class="content-item" v-if="menuTitle==='全部动态' || menuTitle==='新品发布'">
          <div class="content-item-img">
            <img src="../assets/img/home/n_3.png" width="173" height="109">
            <!--<el-tag class="content-item-img-tag" color="#005DAB"
                    style="width: 74px; height: 24px; line-height: 24px; color: #fff; font-size: 15px;border-style: none; padding: 0px; text-align: center; font-weight: bolder;">
              新品发布
            </el-tag>-->
          </div>
          <div class="item_content">
            <span class="item_title">业界首款工业AI服务器面世！</span>
            <span class="item_time">2024-04-01</span>
            <span
                class="item_tip">随着大数据、云计算、深度学习等技术的快速发展，人工智能的应用场景也在不断扩展和深化，AI技术如何大规模实现落地并广泛实际地应用到工业场景当中，是摆在当下最迫切的需求。</span>
          </div>
        </div>
      </router-link>
      <el-divider v-if="menuTitle==='全部动态' || menuTitle==='新品发布'"></el-divider>
      <router-link to="/newsDetails/6">
        <div class="content-item" v-if="menuTitle==='全部动态' || menuTitle==='新品发布'">
          <div class="content-item-img">
            <img src="../assets/img/home/n_4.png" width="173" height="109">
            <!--<el-tag class="content-item-img-tag" color="#005DAB"
                    style="width: 74px; height: 24px; line-height: 24px; color: #fff; font-size: 15px;border-style: none; padding: 0px; text-align: center; font-weight: bolder;">
              新品发布
            </el-tag>-->
          </div>
          <div class="item_content">
            <span class="item_title">引领未来出行新体验：科可瑞尔智能B柱</span>
            <span class="item_time">2024-03-01</span>
            <span class="item_tip">科可瑞尔最新产品——智能B柱，一款旨在重新定义智能出行体验的车载产品。这款智能B柱融合了前沿的人工智能技术，将车辆的安全性与便捷性提升至新的高度，让每一次出行都成为享受科技魅力的旅程。</span>
          </div>
        </div>
      </router-link>
      <el-divider v-if="menuTitle==='全部动态' || menuTitle==='新品发布'"></el-divider>
      <router-link to="/newsDetails/100">
        <div v-if="menuTitle==='全部动态' || menuTitle==='最新动态'" class="content-item">
          <div class="content-item-img">
            <img src="../assets/img/home/n_1.png" width="173" height="109">
            <!--<el-tag class="content-item-img-tag" color="#FFB300"
                    style="width: 74px; height: 24px; line-height: 24px; color: #fff; font-size: 15px;border-style: none; padding: 0px; text-align: center; font-weight: bolder;">
              最新动态
            </el-tag>-->
          </div>
          <div class="item_content">
            <span class="item_title">科可瑞尔2024德国汉堡航展行</span>
            <span class="item_time">2024-05-30</span>
            <span class="item_tip">德国汉堡飞机室内设计及设备展览会（Aircraft Interiors EXPO）是全球最大的飞机内部设计和设备展览会之一，汇聚全球航空业最新的技术创新和设计理念。今年有来自世界70余个国家的400余家企业参展。</span>
          </div>
        </div>
      </router-link>
      <el-divider v-if="menuTitle==='全部动态' || menuTitle==='最新动态'"></el-divider>
      <router-link to="/newsDetails/101">
        <div class="content-item" v-if="menuTitle==='全部动态' || menuTitle==='最新动态'">
          <div class="content-item-img">
            <img src="../assets/img/home/n_2.png" width="173" height="109">
            <!--<el-tag class="content-item-img-tag" color="#FFB300"
                    style="width: 74px; height: 24px; line-height: 24px; color: #fff; font-size: 15px;border-style: none; padding: 0px; text-align: center; font-weight: bolder;">
              最新动态
            </el-tag>-->
          </div>
          <div class="item_content">
            <span class="item_title">2021科可瑞尔入选中国商飞的飞机选型中心</span>
            <span class="item_time"> 2021-10-01</span>
            <span class="item_tip">科可瑞尔作为一家具有机载信息化自主设计与飞机改装设计业务能力的综合性服务企业，成功入选中国商飞的飞机选型中心。在选型中心的展厅中展出了科可瑞尔研发的机载视频监控系统、分布式WiFi系统、Ka空地互联卫星通信系统及。</span>
          </div>
        </div>
      </router-link>
      <el-divider v-if="menuTitle==='全部动态' || menuTitle==='最新动态'"></el-divider>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
      menuTitle: "新品发布",
      pid: 3
    };
  },
  created() {
    this.pid = this.$route.params.id;
    this.selectItem(this.pid);
  },
  methods: {
    selectItem(key) {
      if (key === "1") {
        this.menuTitle = "全部动态";
      } else if (key === "2") {
        this.menuTitle = "最新动态";
      } else if (key === "3") {
        this.menuTitle = "新品发布";
      }
    }
  },
  mounted() {

  },
  watch: {}
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.el-menu {
  border: 1px solid #DFDFDF;
  width: 150px;
  height: 200px;
  text-align: center;
  padding-left: 0px;
}

.el-menu-item.is-active {
  color: #fff !important;
  background-color: #008ED7 !important;
  width: 150px;
  text-align: center;
  padding-left: 0px;
}

.news {
  width: 1160px;
  height: 100%;
  display: flex;
  flex-direction: row;

  .right-content {
    margin-left: 25px;
    display: flex;
    flex-direction: column;

    /*.content-item:first-child {
      margin-top: 0px;
    }*/

    .content-item {
      display: flex;
      flex-direction: row;
      margin: 30px 0px;

      .content-item-img {
        position: relative;

        .content-item-img-tag {
          position: absolute;
          left: 5px;
          top: 5px;
        }
      }
    }
  }

  .item_content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 20px;

    .item_title {
      color: #000;
      font-size: 18px;
      font-weight: bolder;
    }
  }

  .item_time {
    color: #A1A1A1;
    font-size: 14px;
    line-height: 180%;
    padding-bottom: 10px;
  }

  .item_tip {
    color: #A1A1A1;
    font-size: 14px;
    line-height: 180%;
    padding: 0px 0px;
    white-space: pre-wrap; /* 确保文本在一行内显示 */
    overflow: hidden; /* 超出容器部分隐藏 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
  }

  .text-decoration {
    text-decoration: none;
  }
}
</style>